<template>
  <div class="relative h-full min-h-screen max-h-full min-h-full max-w-full min-w-full">
    <div class="p-10">
      <router-view />
    </div>
  </div>
</template>

<script>
import { inject, provide } from 'vue'

export default {
  components: {  },
  setup(){
  }, 
};
</script>

<style>
* {
  background: black;
  font-family: 'Anton', monospace;
  
}


input[type='radio']:checked + span {
  @apply text-black;

}
</style>
